import { render, staticRenderFns } from "./btn-collect.vue?vue&type=template&id=471c81da"
import script from "./btn-collect.vue?vue&type=script&lang=js"
export * from "./btn-collect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports